import FavoriteAction from "./FavoriteAction";

export default FavoriteAction;
